var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.17932 7.79352C3.19013 4.61308 5.77714 2.04358 8.95758 2.05436C12.138 2.06519 14.7075 4.65221 14.6967 7.83265V7.89787C14.6576 9.96526 13.5032 11.8761 12.088 13.3696C11.2787 14.2101 10.3748 14.9541 9.39454 15.587C9.13242 15.8137 8.74362 15.8137 8.4815 15.587C7.02012 14.6358 5.73752 13.4349 4.69236 12.0392C3.76083 10.8221 3.23195 9.34484 3.17932 7.81308V7.79352Z",
    stroke: "#2ECC40",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93806 9.75002C9.95739 9.75002 10.7837 8.92369 10.7837 7.90437C10.7837 6.88504 9.95739 6.05872 8.93806 6.05872C7.91873 6.05872 7.09241 6.88504 7.09241 7.90437C7.09241 8.92369 7.91873 9.75002 8.93806 9.75002Z",
    stroke: "#2ECC40",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.42340b0da0c31f2121787f35f5d3d319.svg";
export { ForwardRef as ReactComponent };